module.exports = __webpack_public_path__ + "media/קר.9d3161dc.mp3";